"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateInput = void 0;
var react_datepicker_1 = require("react-datepicker");
var React = require("react");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var moment = require("moment");
var TextInput_1 = require("../TextInput");
var Dropdown2_1 = require("../Dropdown2");
// import 'react-datepicker/dist/react-datepicker.css'
// import './style.scss'
var TAB_KEYCODE = 9;
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('DateInput'), (0, recompose_1.defaultProps)({
    dateFormat: 'L',
    closeOnSelect: true
}), (0, recompose_1.withState)('raw', 'setRaw', undefined), (0, recompose_1.withState)('isOpen', 'setIsOpen', false), (0, recompose_1.withState)('hasFocus', 'setFocus', false), (0, recompose_1.withState)('tempValue', 'setTempValue', null), (0, recompose_1.lifecycle)({
    componentWillReceiveProps: function (nextProps) {
        if (nextProps.selected !== this.props.selected && nextProps.selected) {
            nextProps.setRaw(nextProps.selected && nextProps.selected.toDate());
        }
    }
}), recompose_1.pure);
var safeFormat = function (date) {
    if (typeof date === 'string') {
        return date;
    }
    return date[0];
};
exports.DateInput = enhance(function (_a) {
    var id = _a.id, inputClassName = _a.inputClassName, dropdownClassName = _a.dropdownClassName, tempValue = _a.tempValue, setTempValue = _a.setTempValue, raw = _a.raw, setRaw = _a.setRaw, isOpen = _a.isOpen, disabled = _a.disabled, setIsOpen = _a.setIsOpen, onChange = _a.onChange, placeholder = _a.placeholder, alignment = _a.alignment, parent = _a.parent, closeOnSelect = _a.closeOnSelect, setFocus = _a.setFocus, hasFocus = _a.hasFocus, rest = __rest(_a, ["id", "inputClassName", "dropdownClassName", "tempValue", "setTempValue", "raw", "setRaw", "isOpen", "disabled", "setIsOpen", "onChange", "placeholder", "alignment", "parent", "closeOnSelect", "setFocus", "hasFocus"]);
    function change(date, e, cb) {
        onChange(moment(date), e);
        if (cb) {
            cb();
        }
    }
    if (!isOpen || !hasFocus) {
        return (React.createElement(TextInput_1.TextInput, { id: id, value: tempValue !== null
                ? tempValue
                : (rest.selected &&
                    rest.selected.format(safeFormat(rest.dateFormat))) ||
                    '', className: classNames('white', inputClassName, disabled ? 'disabled' : ''), placeholder: placeholder, disabled: !!disabled, onFocus: function () {
                if (isOpen) {
                    setIsOpen(false);
                    setFocus(false);
                }
                else {
                    setIsOpen(true);
                    if (!hasFocus) {
                        setFocus(true);
                    }
                }
            }, onBlur: function (e) {
                e.preventDefault();
                setTempValue(null);
                setFocus(false);
            } }));
    }
    if (isOpen && hasFocus) {
        return (React.createElement(Dropdown2_1.Dropdown2, { isOpen: isOpen, clickable: false, onChange: function (status) { return setIsOpen(status); }, className: 'sok-datepicker-container', alignment: alignment, parent: parent },
            React.createElement(TextInput_1.TextInput, { autoFocus: true, id: id, value: tempValue !== null
                    ? tempValue
                    : (rest.selected &&
                        rest.selected.format(safeFormat(rest.dateFormat))) ||
                        '', className: classNames('white', inputClassName, disabled ? 'disabled' : ''), placeholder: placeholder, disabled: !!disabled, onChange: function (e) {
                    e.preventDefault();
                    setTempValue(e.target.value);
                    var date = moment(e.target.value, rest.dateFormat);
                    if (date.isValid()) {
                        if (rest.showTimeSelect && rest.selected) {
                            var updated = rest.selected
                                .clone()
                                .set('date', date.date())
                                .set('month', date.month())
                                .set('year', date.year());
                            onChange(updated, e);
                        }
                        else {
                            onChange(date, e);
                        }
                    }
                    else {
                        onChange(null, e);
                    }
                }, onKeyDown: function (e) {
                    if (e.keyCode === TAB_KEYCODE) {
                        setFocus(false);
                        return;
                    }
                }, onFocus: function () { return setIsOpen(true); }, onBlur: function (e) {
                    e.preventDefault();
                    setTempValue(null);
                } }),
            !disabled ? (React.createElement(Dropdown2_1.Dropdown2Menu, { className: classNames('sok-datepicker-menu', dropdownClassName), ignoreWidth: true },
                React.createElement(Dropdown2_1.ClickWall, null,
                    React.createElement(Dropdown2_1.Dropdown2MenuItem, { className: 'sok-datepicker-menu-item' },
                        React.createElement(react_datepicker_1.default, __assign({}, rest, { inline: true, minTime: rest.minTime && rest.minTime.toDate(), maxTime: rest.maxTime && rest.maxTime.toDate(), maxDate: rest.maxDate && rest.maxDate.toDate(), minDate: rest.minDate && rest.minDate.toDate(), filterDate: function (date) {
                                if (!rest.filterDate) {
                                    return true;
                                }
                                return rest.filterDate(moment(date));
                            }, selected: raw
                                ? raw
                                : (rest.selected && rest.selected.toDate()) || '', onClickOutside: function () {
                                setIsOpen(false);
                                setTempValue(null);
                            }, onChange: function (date, e) {
                                setTempValue(null);
                                setRaw(date);
                                if (rest.showTimeSelect === true) {
                                    change(date, e);
                                    if (closeOnSelect === true && !e) {
                                        setIsOpen(false);
                                    }
                                    return;
                                }
                                change(date, e, function () { return setIsOpen(false); });
                                if (closeOnSelect === true) {
                                    setIsOpen(false);
                                }
                            } })))))) : null));
    }
});
//# sourceMappingURL=index.js.map